// src/services/api.ts
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { logout } from "@/store/authSlice";

const baseQuery = fetchBaseQuery({
  baseUrl: import.meta.env.VITE_API_URL || "https://api.medxprohealth.com/api",
  credentials: "include",
  prepareHeaders: (headers, { getState }: any) => {
    const token = getState().auth?.token;
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

// Handle token refresh
const baseQueryWithReauth = async (args: any, api: any, extraOptions: any) => {
  let result = await baseQuery(args, api, extraOptions);

  if (result.error?.status === 401) {
    // Try to refresh token
    const refreshResult = await baseQuery(
      { url: "/auth/refresh", method: "POST" },
      api,
      extraOptions
    );

    if (refreshResult.data) {
      // Retry original request (reauth success)
      result = await baseQuery(args, api, extraOptions);
    } else {
      // Reauth failed - force logout
      api.dispatch(logout());
    }
  }
  return result;
};

export const api = createApi({
  reducerPath: "api",
  baseQuery: baseQueryWithReauth,
  tagTypes: [
    "Vendors",
    "Clinics",
    "Tests",
    "ClinicTests",
    "Clients",
    "Users",
    "Employees",
    "Reports",
    "DrugPanels",
    "ClientPricing",
    "ClientMargins",
    "Auth",
    "Labs",
    "TestCategories",
    "DrugComponents",
    "VendorAliases",
    "ClientPricingContracts",
    "Orders",
    "VisitorLabReports",
    "Visitors",
    "VisitorTests"
  ],
  endpoints: () => ({}),
});
